
































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import RegisteredUserInfo, {
  jsobRoles
} from '../../../modules/class/RegisteredUserInfo'
import { membershipState } from '../../../store/modules/MembershipState'
import Item from '../../../modules/class/Item'
import { DownloadStatus } from '../../../modules/class/Downloads'
import JsonUtil from '../../../modules/util/JsonUtil'
import PathUtil from '../../../modules/util/PathUtil'
import { getUserInfo, ssoLogin } from '../../../modules/util/SapUtil'
import FormResultError from '@/components/Parts/FormResultError.vue'

@Component({
  components: {
    FormResultError
  }
})
export default class RegisterAdditionalModalComponent extends Vue {
  private readonly vueid = 'vue_register_additional_modal_component'

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  // PDFのDL-URL. 会員情報追加成功後に利用する
  @Prop() private accessUrl!: string

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private isFormVisible = true
  private messageHeadline = ''
  private message1 = ''
  private message2 = ''
  private jsobRoleOptions: string[] = jsobRoles
  private country: Item[] = []
  private resultError: ErrorFormResponse = {}
  private emailSubscription = false

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get level(): number {
    return membershipState.level
  }

  get userInfo(): RegisteredUserInfo {
    return membershipState.userInfo
  }

  get useDoubleOptIn(): boolean {
    return drupalSettings.vueComponent.useDoubleOptIn.enable ?? false
  }

  get isSubscribedEmail(): boolean {
    return membershipState.userInfo.emailSubscription
  }

  // -------------------------------------------------------------------------------------------------------------------
  // hooks
  private created() {
    this.resultError = {}
    this.isFormVisible = true
  }

  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      this.fetchCountry()
      // 必須会員情報(email)が無い場合SAPに会員情報を取得しに行く
      if (this.userInfo.email === '') {
        getUserInfo()
      }
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
  private async fetchCountry() {
    const res = await axios.post(PathUtil.makePath('/member/api/country'))
    if (res === undefined || res.status !== 200) {
      // TODO: システムエラー時の処理を作成する
      return
    }
    this.country = res.data.country.map(
      (d: { id: string; name: string }) => new Item(d.id, d.name)
    )
  }

  private close() {
    membershipState.addIsRegisterAdditionalModalVisible(false)
  }

  /**
   * 会員情報追加フォームに入力された値で、会員情報追加APIにPOSTする。
   */
  private async registerAdditional() {
    let form = {
      level: this.level,
      organization: this.userInfo.organization,
      job_roles: this.userInfo.jobRoles,
      country_region: this.userInfo.countryRegion,
      email: membershipState.userInfo.email,
      password: this.userInfo.password
    }
    if (this.level === 3) {
      form = Object.assign(form, {
        phone: this.userInfo.phone,
        mobile_phone: this.userInfo.mobilePhone,
        address: this.userInfo.address,
        city: this.userInfo.city,
        state: this.userInfo.state,
        zip_code: this.userInfo.zipCode,
        department: this.userInfo.department
      })
    }

    // メルマガ未登録状態の時のみPOST
    if (!this.isSubscribedEmail) {
      form = Object.assign(form, {
        email_subscriptions: this.emailSubscription
      })
    }

    try {
      const res = await axios.post(
        PathUtil.makePath('/member/api/level_up'),
        form
      )
      const result = res.data.result
      if (result === 'success') {
        // DL要求時の権限Upの場合、2:権限不足→5:DL再トライ待ちにステータス変更
        if (
          membershipState.pdfDownloadAccessUrl !== '' &&
          membershipState.pdfDownloadStatus === DownloadStatus.UnderLevels
        ) {
          membershipState.addDownloadStatus(DownloadStatus.ReDownloadWait)
          // 会員登録追加完了画面を表示
          membershipState.addIsRegisterModalAddCompleteVisible(true)
        }
        // アナリティクス
        // 失敗しても処理継続する
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'mypage-level': res.data.member_level,
          event: 'MypageLevelChangeEvent'
        })
        // この画面を閉じる
        this.close()
      } else {
        this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
          ErrorFormResponse,
          res.data.errordata || {}
        )
      }
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 403) {
        ssoLogin(window.location.href, 'gigya-login-screen')
      }
    }
  }
}
